
import { Opcao } from '@/dominio/formulario/questoes/opcoes/Opcao';
import { QuestaoDeOpcoes } from '@/dominio/formulario/questoes/opcoes/QuestaoDeOpcoes';
import { defineComponent } from 'vue';
import OpcaoComponent from './OpcaoComponent.vue';
import VariavelComponent from './VariavelComponent.vue';

export default defineComponent({
    name: 'QuestaoOpcoesComponent',
    props: {
        questao: {
            type: QuestaoDeOpcoes,
            required: true,
        },
    },
    data() {
        return {
            minhaQuestao: this.questao,
        };
    },
    components: {
        OpcaoComponent,
        VariavelComponent,
    },
    emits: ['opcaoSelecionada'],
    methods: {
        receberOpcaoSelecionada(opcao: Opcao) {
            this.minhaQuestao.setValorSelecionado(opcao);
            this.$emit('opcaoSelecionada', opcao);
        },
    },
});
